export const getNextRevealChunk = (
  displayedText: string,
  targetText: string
): string => {
  if (displayedText.length >= targetText.length) {
    return "";
  }

  const remainingText = targetText.slice(displayedText.length);
  return remainingText.match(/^\s*\S+/)?.[0] ?? remainingText;
};
